<template>
  <div>
    <basic-container>
      <div>
        <el-form
          ref="form"
          :model="projectItemForm"
        >

          <el-form-item
            label="工程项目名称"
            label-width="100px"
          >

            <div style="display: flex;width:300px;">
              <el-input
                v-model="projectItemForm.name"
                placeholder='请输入工程项目名称'
              ></el-input>
            </div>
          </el-form-item>
          <!-- <el-form-item
            label="关联服务商"
            label-width="100px"
          >
            <div style="display: flex;width:300px;">
              <el-select
                v-model="projectItemForm.agentId"
                placeholder="请选择关联服务商"
                width="200"
                @change="aasscc"
              >
                <el-option
                  v-for="item in agentIds"
                  :key="item.id"
                  :label="item.company"
                  :value='item.id'
                ></el-option>
              </el-select>
            </div>
          </el-form-item> -->
          <el-form-item label="工程预约配置">
            <el-table
              :data="tableData"
              :span-method="objectSpanMethod"
              border
              style="width: 100%; margin-top: 20px"
            >

              <el-table-column
                prop="clientType"
                align="center"
                label="预约渠道"
              >
                <template slot-scope="scope">
                  <el-select
                    v-model="scope.row.clientType"
                    placeholder="请选择预约渠道"
                    width="300"
                  >
                    <el-option
                      v-for="item in clientTypes"
                      :key="item.value"
                      :label="item.label"
                      :value='item.value'
                    ></el-option>
                  </el-select>
                </template>

              </el-table-column>

              <el-table-column
                prop="auditor"
                align="center"
                label="审核方"
                min-width="100"
              >
                <template slot-scope="scope">
                  <el-select
                    v-model="scope.row.auditor"
                    placeholder="审核方"
                    width="300"
                  >
                    <el-option
                      v-for="item in auditors"
                      :key="item.value"
                      :label="item.label"
                      :value='item.value'
                    ></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column
                prop="payer"
                align="center"
                label="支付方"
                min-width="100"
              >
                <template slot-scope="scope">
                  <el-select
                    v-model="scope.row.payer"
                    placeholder="请选择支付方"
                    width="300"
                  >
                    <el-option
                      v-for="item in payers"
                      :key="item.value"
                      :label="item.label"
                      :value='item.value'
                    ></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column
                prop="area"
                min-width="120"
                align="center"
                label="服务区域"
              >
                <template slot-scope="scope">
                  <div>
                    <div>
                      <el-select
                        v-model="scope.row.provinces"
                        size="small"
                        @change="chooseProvince(scope.row.provinces,scope)"
                        placeholder="请选择省份"
                        value-key="id"
                        clearable
                      >
                        <el-option
                          v-for="item in provinces"
                          :key="item.id"
                          :label="item.name"
                          :value="item"
                        ></el-option>
                      </el-select>
                    </div>
                    <div>
                      <el-select
                        v-model="scope.row.citys"
                        size="small"
                        @change="chooseCity(scope.row.citys,scope)"
                        value-key="id"
                        placeholder="请选择城市"
                        clearable
                      >
                        <el-option
                          v-for="item in scope.row.citysList"
                          :key="item.id"
                          :label="item.name"
                          :value="item"
                        ></el-option>
                      </el-select>
                    </div>
                    <div>
                      <el-select
                        v-model="scope.row.areas"
                        size="small"
                        @change="chooseArea(scope.row.areas,scope)"
                        value-key="id"
                        placeholder="请选择地区"
                        clearable
                      >
                        <el-option
                          v-for="item in scope.row.areasList"
                          :key="item.id"
                          :label="item.name"
                          :value="item"
                        ></el-option>
                      </el-select>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                label="操作"
                width="120"
              >

                <template slot-scope="scope">
                  <el-button
                    type="danger"
                    icon="el-icon-close"
                    size="small"
                    @click="handleSteppingDelete(scope.$index, scope.row)"
                  >删除
                  </el-button>
                </template>
              </el-table-column>

              <el-table-column
                align="center"
                label="配置"
                width="150"
              >
                <template slot-scope="scope">
                  <el-button
                    type="warning"
                    icon="el-icon-check"
                    size="small"
                    @click="handleAddRows(scope.$index, scope.row)"
                  >增加一行</el-button>
                </template>
              </el-table-column>
              <template slot="empty">
                <el-button
                  type="warning"
                  icon="el-icon-check"
                  size="small"
                  style="margin: 20px 0"
                  @click="handleAddRows()"
                >增加一行</el-button>
              </template>
            </el-table>
          </el-form-item>
          <el-form-item label="工程阶段配置">
            <el-table
              :data="tableData1"
              :span-method="objectSpanMethod"
              border
              style="width: 100%; margin-top: 20px"
            >

              <el-table-column
                prop="name"
                align="center"
                label="工程阶段名称"
                min-width="100"
              >
                <template slot-scope="scope">
                  <el-input
                    type="input"
                    name="name"
                    size="small"
                    v-model="scope.row.name"
                    :value="scope.row.name"
                    placeholder="请输入工程阶段名称"
                  ></el-input>
                </template>
              </el-table-column>

              <el-table-column
                prop="isVisit"
                align="center"
                label="工程费用"
                min-width="100"
              >
                <template slot-scope="scope">
                  <el-radio
                    v-model="scope.row.isVisit"
                    label="YES"
                  >
                    有
                  </el-radio>
                  <el-radio
                    v-model="scope.row.isVisit"
                    label="NO"
                  >
                    无
                  </el-radio>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                prop="engineeringCost"
                label="工程费用明细"
                min-width="100"
              >
                <template slot-scope="scope">
                  <el-input
                    type="input"
                    name="engineeringCost"
                    size="small"
                    v-if="scope.row.isVisit =='YES'"
                    v-model="scope.row.engineeringCost"
                    :value="scope.row.engineeringCost"
                    placeholder="请输入工程费用明细"
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                prop="sort"
                label="排序"
                min-width="100"
              >
                <template slot-scope="scope">
                  <el-input
                    type="input"
                    name="sort"
                    size="small"
                    v-model="scope.row.sort"
                    :value="scope.row.sort"
                    placeholder="排序"
                  ></el-input>
                </template>
              </el-table-column>

              <el-table-column
                align="center"
                label="操作"
                width="120"
              >

                <template slot-scope="scope">
                  <el-button
                    type="danger"
                    icon="el-icon-close"
                    size="small"
                    @click="handleStepping1Delete(scope.$index, scope.row)"
                  >删除
                  </el-button>
                </template>
              </el-table-column>

              <el-table-column
                align="center"
                label="配置"
                width="150"
              >
                <template slot-scope="scope">
                  <el-button
                    type="warning"
                    icon="el-icon-check"
                    size="small"
                    @click="handleAdd1Rows(scope.$index, scope.row)"
                  >增加一行</el-button>
                </template>
              </el-table-column>
              <template slot="empty">
                <el-button
                  type="warning"
                  icon="el-icon-check"
                  size="small"
                  style="margin: 20px 0"
                  @click="handleAdd1Rows()"
                >增加一行</el-button>
              </template>
            </el-table>
          </el-form-item>
        </el-form>
        <div style='width:100%;display:flex;flex-flow:row nowrap;justify-content: center;margin-top:20px'>
          <el-button
            type="primary"
            size="big"
            @click="submit"
          >确定修改</el-button>
        </div>
      </div>
    </basic-container>
  </div>
</template>

<script>
import { DIC } from "@/const/dic";
import { resolveUrlPath, setUrlPath } from "@/util/util";
import {
  findAllSuperiorDepartment,
  findEngineeringProjectDetail,
  editEngineeringProject,
  findProvince,
  findCitys,
  findAreas
} from "@/api/work/projectItem";

export default {
  data() {
    return {
      projectItemForm: {},
      isTop: "YES",
      clientTypes: DIC.SERVICEITEM_TYPE,
      payers: DIC.SERVICEITEM_PAYER,
      auditors: DIC.SERVICEITEM_AUDITOR,
      areas: [],
      citys: [],
      provinces: [],
      tableData: [],
      tableData1: []
    };
  },
  created() {
    findEngineeringProjectDetail(this.$router.currentRoute.query.id).then(
      res => {
        let data = JSON.parse(res.data);
        console.log(data);
        this.projectItemForm.name = this.$router.currentRoute.query.aname;
        this.projectItemForm.agentId = this.$router.currentRoute.query.agentId;
        for (let j of data.stageRequestList) {
          if (j.engineeringCost) {
            j.isVisit = "YES";
          } else {
            j.isVisit = "NO";
          }
        }
        for (let i of data.reservationConfigList) {
          console.log(i);
          i.provinces = {};
          i.provinces.id = i.province;
          i.provinces.name = i.provinceName;

          i.citysList = [];

          i.citys = {};
          i.citys.id = i.city;
          i.citys.name = i.cityName;

          i.areasList = [];

          i.areas = {};
          i.areas.id = i.area;
          i.areas.name = i.areaName;
          if (i.pca) {
            if (i.pca.cities) {
              i.citysList = i.pca.cities;
            }
            if (i.pca.areas) {
              i.areasList = i.pca.areas;
            }
          }
        }
        this.tableData1 = data.stageRequestList;
        this.tableData = data.reservationConfigList;
      }
    );
    // findAllSuperiorDepartment().then(res => {
    //   let data = JSON.parse(res.data);
    //   console.log(data);

    //   this.agentIds = data;
    //   this.agentIds.unshift({ company: "社区", id: "0" });
    // });
    findProvince().then(res => {
      // let data = JSON.parse(res.data);
      console.log(res);
      this.provinces = res.data;
      this.currentProvince = "";
      this.currentCity = "";
      this.currentArea = "";
    });
  },
  methods: {
    aasscc() {},
    chooseProvince(provinces, scope) {
      console.log(provinces);
      console.log(scope);
      findCitys(provinces.id).then(res => {
        //   console.log(res);
        scope.row.citysList = res.data;
        scope.row.citys = {};
        scope.row.areas = {};
        //   console.log(scope);
      });
    },
    chooseCity(citys, scope) {
      findAreas(citys.id).then(res => {
        scope.row.areasList = res.data;
        scope.row.areas = {};
      });
    },
    chooseArea(areas, scope) {
      console.log(areas);
    },
    submit() {
      let item = {
        close: true,
        label: "编辑工程项目",
        value: "/work/projectItem/edit"
      };
      // this.$store.commit("DEL_TAG", item);
      // let obj = {
      //   value: "/work/projectItem",
      //   label: "工程项目管理"
      // };
      // this.$router.push({
      //   path: resolveUrlPath(obj.value, obj.label),
      //   query: obj.query
      // });
      let params = this.projectItemForm;
      if (!this.projectItemForm.name) {
        this.$message({
          showClose: true,
          message: "请输入工程项目名称",
          type: "error"
        });
        return;
      }
      // if (!this.projectItemForm.agentId) {
      //   this.$message({
      //     showClose: true,
      //     message: "选择关联服务商",
      //     type: "error"
      //   });
      //   return;
      // }
      if (this.tableData.length == 0) {
        this.$message({
          showClose: true,
          message: "请输入工程预约配置",
          type: "error"
        });
        return;
      }
      if (this.tableData1.length == 0) {
        this.$message({
          showClose: true,
          message: "请输入工程阶段配置",
          type: "error"
        });
        return;
      }
      let array = [];
      for (let i = 0; i < this.tableData.length; i++) {
        let obj = {};
        if (this.tableData[i].provinces) {
          obj.province = this.tableData[i].provinces.id;
          obj.provinceName = this.tableData[i].provinces.name;
        }
        if (this.tableData[i].citys) {
          obj.city = this.tableData[i].citys.id;
          obj.cityName = this.tableData[i].citys.name;
        }
        if (this.tableData[i].areas) {
          obj.areaName = this.tableData[i].areas.name;
          obj.area = this.tableData[i].areas.id;
        }
        obj.clientType = this.tableData[i].clientType;
        obj.payer = this.tableData[i].payer;
        obj.id = this.tableData[i].id;
        obj.auditor = this.tableData[i].auditor;
        array.push(obj);
        console.log(obj);
      }
      params.reservationConfigList = array;
      params.id = this.$router.currentRoute.query.id;
      console.log(this);
      for (let i = 0; i < this.tableData1.length; i++) {
        if (!this.tableData1[i].name) {
          this.$message({
            showClose: true,
            message: "请输入工程阶段名称",
            type: "error"
          });
          return;
        }
        if (
          !this.tableData1[i].engineeringCost &&
          this.tableData1[i].isVisit == "YES"
        ) {
          this.$message({
            showClose: true,
            message: "请输入工程费用明细",
            type: "error"
          });
          return;
        }
        if (!this.tableData1[i].sort) {
          this.$message({
            showClose: true,
            message: "请输入排序",
            type: "error"
          });
          return;
        }
      }
      params.stageRequestList = this.tableData1;
      console.log(params);
      editEngineeringProject(params).then(res => {
        if (res.code == "200") {
          this.$message({
            showClose: true,
            message: "修改成功",
            type: "success"
          });
          if (!this.isPas) {
            this.$store.commit("DEL_TAG", item);
            let obj = {
              value: "/work/projectItem",
              label: "工程项目管理"
            };
            this.$router.push({
              path: resolveUrlPath(obj.value, obj.label),
              query: obj.query
            });
            this.isPas = true;
          }
        } else {
          if (!this.isPas) {
            this.$message({
              showClose: true,
              message: res.message,
              type: "error"
            });
            this.isPas = true;
            setTimeout(() => {
              this.isPas = false;
            }, 1000);
          }
        }
      });
    },
    handleSteppingDelete(index, row) {
      //   this.propertiesList.splice(index, 1);

      this.tableData.splice(index, 1);
    },
    handleStepping1Delete(index, row) {
      //   this.propertiesList.splice(index, 1);

      this.tableData1.splice(index, 1);
    },
    handleAddRows(index, row) {
      console.log(this.tableData);
      let list = {
        citysList: [],
        areasList: []
      };
      this.tableData.push(list);
    },
    handleAdd1Rows(index, row) {
      console.log(this.tableData1);
      let list = {
        isVisit: "YES"
      };
      this.tableData1.push(list);
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 5) {
        if (rowIndex % 100 === 0) {
          return {
            rowspan: 100,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    }
  }
};
</script>

<style>
</style>